import { render, staticRenderFns } from "./SystemInformationModal.vue?vue&type=template&id=b01d0fa6&scoped=true"
import script from "./SystemInformationModal.vue?vue&type=script&lang=js"
export * from "./SystemInformationModal.vue?vue&type=script&lang=js"
import style0 from "./SystemInformationModal.vue?vue&type=style&index=0&id=b01d0fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d0fa6",
  null
  
)

export default component.exports